import ErrorButton from 'components/Errors/ErrorButton/ErrorButton';

import ErrorCard from 'components/Errors/ErrorCard/ErrorCard';
import {
  ERROR_PAGE_BUTTONS,
  ERROR_PAGE_IMAGES,
  ERROR_PAGE_SUBTITLES,
  ERROR_PAGE_TITLES,
  UNAUTHORIZED,
} from 'constants/error';
import { Center, Image, Stack, Text, Flex } from '@mantine/core';
import { capitalizeWords } from 'helpers/format.cuboh';

interface ErrorCardByTypeProps {
  type?: 'unauthorized' | 'general' | 'notFound';
  buttonLabel?: (typeof ERROR_PAGE_BUTTONS)[keyof typeof ERROR_PAGE_BUTTONS];
  customStyles?: React.CSSProperties;
}

export default function ErrorCardByType({
  type = UNAUTHORIZED,
  buttonLabel = ERROR_PAGE_BUTTONS.contactSupport,
  customStyles,
}: ErrorCardByTypeProps) {
  return (
    <ErrorCard button={<ErrorButton label={buttonLabel} />} customStyles={customStyles}>
      <Stack gap="md">
        <Center>
          <Flex
            bg="var(--mantine-color-neutral-1)"
            h={80}
            w={80}
            align="center"
            justify="center"
            style={{
              borderRadius: 'var(--mantine-radius-xs)',
            }}
          >
            <Image w={70} src={ERROR_PAGE_IMAGES[type]} />
          </Flex>
        </Center>
        <Stack gap="sm">
          <Text variant="label-lg" ta="center">
            {capitalizeWords(ERROR_PAGE_TITLES[type])}
          </Text>
          <Text variant="body-md" ta="center">
            {ERROR_PAGE_SUBTITLES[type]}
          </Text>
        </Stack>
      </Stack>
    </ErrorCard>
  );
}
